#!/usr/bin/env node
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMNator = void 0;
var fs_1 = __importDefault(require("fs"));
var YAMLParser_1 = require("../parser/YAMLParser");
var BPMNBuilder_1 = require("../bpmnbuilder/BPMNBuilder");
var BPMNator = (function () {
    function BPMNator() {
    }
    Object.defineProperty(BPMNator.prototype, "LastError", {
        get: function () {
            return this.lastError;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNator.prototype, "BPMN", {
        get: function () {
            return this._BPMN;
        },
        enumerable: false,
        configurable: true
    });
    BPMNator.prototype.ProduceBPMN = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.DiagramPreprod()];
                    case 1:
                        _a.sent();
                        this._BPMN = this.builder.BPMN;
                        return [2, this._BPMN];
                }
            });
        });
    };
    BPMNator.prototype.SaveBPMN = function (DestinationURI, charset) {
        if (charset === void 0) { charset = 'utf8'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.DiagramPreprod()];
                    case 1:
                        _a.sent();
                        return [2, this.saveSomethingToURI(this.builder.BPMN, DestinationURI, charset)];
                }
            });
        });
    };
    BPMNator.prototype.LoadYAMLbyURI = function (URI, charset) {
        if (charset === void 0) { charset = 'utf8'; }
        this.parser = new YAMLParser_1.YAMLParser('uri', URI, charset);
        this.lastError = this.parser.Error;
        return this.parser.NoError;
    };
    BPMNator.prototype.LoadYAMLbyContent = function (Content) {
        this.parser = new YAMLParser_1.YAMLParser('content', Content);
        this.lastError = this.parser.Error;
        return this.parser.NoError;
    };
    BPMNator.prototype.BuildProcess = function () {
        this.builder = new BPMNBuilder_1.BPMNBuilder(this.parser.Process);
        this.lastError = this.builder.Error;
        return this.builder.NoError;
    };
    BPMNator.prototype.SaveBPMNWithoutDiagram = function (DestinationURI, charset) {
        if (charset === void 0) { charset = 'utf8'; }
        var BPMN = this.ProduceBPMNWithoutDiagram();
        if (BPMN !== null) {
            return this.saveSomethingToURI(BPMN, DestinationURI, charset);
        }
        else
            return false;
    };
    BPMNator.prototype.ProduceBPMNWithoutDiagram = function () {
        this.builder.BuildBPMNWithoudDiagram();
        this.lastError = this.builder.Error;
        if (this.builder.NoError)
            return this.builder.BPMNWithoutDiagram;
        else
            return null;
    };
    BPMNator.prototype.saveSomethingToURI = function (content, URI, charset) {
        if (charset === void 0) { charset = 'utf8'; }
        try {
            fs_1.default.writeFileSync(URI, content, { encoding: charset });
            return true;
        }
        catch (e) {
            this.lastError = e.message;
            console.log(e.message);
            return false;
        }
    };
    BPMNator.prototype.DiagramPreprod = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clog;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.builder.BuildBPMNWithoudDiagram();
                        clog = console.log;
                        console.log = function () { };
                        return [4, this.builder.produceDiagram()];
                    case 1:
                        _a.sent();
                        this.lastError = this.builder.Error;
                        console.log = clog;
                        return [2];
                }
            });
        });
    };
    return BPMNator;
}());
exports.BPMNator = BPMNator;

if (typeof (process) != 'undefined') {
    try {
        var bpmnator = new BPMNator();
        var argv = process.argv;
        switch (argv.length) {
            case 3:
            case 4:
                if (bpmnator.LoadYAMLbyURI(argv[2])) {
                    if (bpmnator.BuildProcess()) {
                        switch (argv.length) {
                            case 3:
                                bpmnator.ProduceBPMN().then(function (val) { return console.log(val); });
                                break;
                            case 4:
                                bpmnator.SaveBPMN(argv[3]);
                                break;
                        }
                    }
                }
                break;
            default:
                console.log("\n                BPMNator -- command line version\n                ################################\n    \n                Usage: \n                    - node dist/bin/bpmnator 'uri-input-yaml'\n                    (this will print to stdout the bpmn)\n    \n                    or\n    \n                    - node dist/bin/bpmnator 'uri-input-yaml' 'uri-output-bpmn'\n                    (this will save the bpmn)\n                ");
                break;
        }
    }
    catch (e) {
        console.log(e);
    }
}
//# sourceMappingURL=bpmnator.js.map